import { render, staticRenderFns } from "./SubjectDetail4.vue?vue&type=template&id=0d0cbcf4&scoped=true&"
import script from "./SubjectDetail4.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail4.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail4.vue?vue&type=style&index=0&id=0d0cbcf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0cbcf4",
  null
  
)

export default component.exports